import * as ng from 'angular';
import * as nggt from 'angular-gettext';
import * as uir from '@uirouter/angularjs';

import { SiteConfig, Loader, SyncService } from '../shared';
export class MediaUploadController implements ng.IComponentController {
   static $inject = ['$sce', '$window', '$stateParams', '$state', 'config', 'loader', 'gettextCatalog', '$timeout', 'syncService'];

   imagePreview: string | ArrayBuffer | null = null;
   errors: string[];
   maxFileSizeMB = 5; // Max file size in MB
   allowedTypes = ['image/jpeg', 'image/png', 'image/gif']; // Allowed MIME types
   fileModel: any;
   
   wristbandId: string;
   eventId: number;

   LayoutView = {
      FORM: 'form',
      FORM_BOT_CHECK: 'bot_check',
      FORM_ERROR: 'error'
   };

   mode = this.LayoutView.FORM;

   constructor(
      private $sce:ng.ISCEService,
      private $window:ng.IWindowService,
      $stateParams:uir.StateParams,
      private $state:uir.StateService,
      private config:SiteConfig,
      private loader:Loader,
      private gettextCatalog:nggt.gettextCatalog,
      private $timeout:ng.ITimeoutService,
      private syncService:SyncService
   ) {
      this.wristbandId = $stateParams.wristbandId;
      this.eventId = $stateParams.eventId;
   }

   $onInit() {
      if (!this.config.settings.requireMediaUpload) {
         this.errors = ['experience_no_media_support'];
      }
   }

   get language() {
      return this.gettextCatalog.getCurrentLanguage();
   }

   get titleText() {
      return this.config.settings.mediaUploadTitle[this.language];
   }

   get extraText() {
      const text = this.config.settings.mediaUploadText[this.language];
      if (text) {
         return this.$sce.trustAsHtml(text);
      }
   }

   get mediaUploadRequired() {
      return this.config.settings.requireMediaUpload;
   }

   onFileSelected = (file: File | null): void => {
      if (!file) return;

      this.errors = null;

      // Validate file type
      if (!this.allowedTypes.includes(file.type)) {
         this.errors = ['invalid_file_type']
         return;
      }
   
      // Validate file size
      const maxSizeBytes = this.maxFileSizeMB * 1024 * 1024;
      if (file.size > maxSizeBytes) {
         this.errors = ['file_size_limit_exceeded'];
         file = null;
         return;
      }

      this.imagePreview = null;
      this.fileModel = file;

      const reader = new FileReader();
      reader.onload = (e: ProgressEvent<FileReader>) => {
         this.$timeout(() => {
            this.imagePreview = e.target?.result as string;
         });
      };
      reader.readAsDataURL(file);
   };

   onContinue() {
      this.initilizeTurnstile();
   }

   initilizeTurnstile() {
      this.mode = this.LayoutView.FORM_BOT_CHECK;
   }

   onTurnstileCallback(token:string) {
      this.submit(token);
   }

   onTurnstileErrorCallback() {
      this.mode = this.LayoutView.FORM_ERROR;
   }

   submit(token) {
      this.errors = null;
      this.loader.loading = true;

      let base64Str = this.imagePreview.toString().split(',')[1];

      let participant = this.syncService.getParticipant();
      if (!participant) {
         
      }
      this.syncService.submit(participant, token).then(() => {
         this.syncService.submitMedia(this.wristbandId, this.eventId, this.fileModel.name, base64Str).then(() => {
            this.syncService.removeParticipant();
            this.$state.go('shell.confirm', {
               wristbandId: this.wristbandId
            });
         });
      }).catch(response => {
         if (response.data.errors && response.data.errors['']) {
            this.errors = response.data.errors[''];
         }
      }).finally(() => this.loader.loading = false);
   }
}

ng.module('selfReg').component('mediaUpload', {
   templateUrl: require('./media-upload.html'),
   controller: MediaUploadController
});
